import styled from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';

export const Wrapper = withTheme(styled.div`
  width: ${p => p.size};
  height: ${p => p.size};
`);
